import {
  SET_LOADING,
  SET_ERROR,
  SET_TOKEN,
} from '../actions/global';

const INITIAL_STATE = {
  error: null,
  loading: false
};

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case SET_TOKEN:
      return Object.assign({}, state, {token: action.value});
    case SET_LOADING:
      return Object.assign({}, state, {loading: action.value});
    case SET_ERROR:
      let error = action.value;
      return Object.assign({}, state, {error: error});
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/global.js